// extracted by mini-css-extract-plugin
module.exports = {"skipButton":"SkipLeadForm_skipButton__mtqDz","skipButtonColour":"SkipLeadForm_skipButtonColour__dGdNW","skipButtonColourSpinner":"SkipLeadForm_skipButtonColourSpinner__WsIVL"};